import { render } from "./BrandMeinSonntag.vue?vue&type=template&id=4e2f57ce"
import script from "./BrandMeinSonntag.vue?vue&type=script&lang=ts"
export * from "./BrandMeinSonntag.vue?vue&type=script&lang=ts"

import "./BrandMeinSonntag.vue?vue&type=style&index=0&id=4e2f57ce&lang=scss"
script.render = render

export default script